module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAQklEQVQ4jWNgGAWMMIanp+d/XIq2b9/OiEuOti5At9nT0/M/shg+V+MEME0wmqwwQHcJbVyAzQaqhAE6GPh0MPAAAOa0KyKr7IZQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/icon-sort-remove.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/icon-sort-remove.png
// module chunks = styles